module.exports = __webpack_public_path__ + "static/media/V2_19.268ca265.png";